const people1 = {
    number: "1/3",
    question: "The People",
    description: `When you look back at the times when you were passionate
                                of what you were doing, who were the people that you were
                                helping? Think of them, then describe their personality in adjectives.
                                e.g. gamechangers, energetic, fun etc.`
}

const people2 = {
    number: "2/3",
    question: "The People",
    description: `Now let's look at the people you are targeting with your business today. 
    Write who they are. e.g. Founders, CEOs, CTOs etc.`
}

const combine = {
    number: "3/3",
    question: "Combine",
    description: `Business is done with people. Very often, the people we have connected with in the past show us who we can more easily connect with in the future.
     So, to move forward, combine a representative adjective with your new target audience and see how that connects with you. E.g. Energetic Founders, or Engaging Executives.`
}

export const questions = {
    people1: people1,
    people2: people2,
    combine: combine,
}

const people1Video = {
    url: "https://www.dropbox.com/scl/fi/c0ih5au8dscl0pkzyoonp/8-The-people-you-love-helpign.mp4?rlkey=6llxhirwznaok9i45dme674t5&raw=1"
}

const people2Video = {
    url: "https://www.dropbox.com/scl/fi/4kg6r8qfcmv62zschqerp/9-The-people-you-are-going-to-help.mp4?rlkey=nxd9onulz8jk79y6nw8m48vqj&raw=1"
}

const combineVideo = {
    url: "https://www.dropbox.com/scl/fi/0ums4fh3vkd8ihbpgpxzm/10-The-Persona.mp4?rlkey=mw1e84n6avebjg75eyx81vjex&raw=1"
}

export const videos = {
    people1Video: people1Video,
    people2Video: people2Video,
    combineVideo: combineVideo,
}